export default Object.freeze({
  standard: 'STRD',
  plus: 'ENCF',
})
